function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    stroke: ", ";\n    stroke-width: 1;\n    stroke-dasharray: 57;\n    stroke-dashoffset: 57;\n\n    &.checked {\n      stroke-dashoffset: 0;\n    }\n\n    &.disabled {\n      fill: ", ";\n      stroke-dashoffset: 0;\n      stroke: ", ";\n    }\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    stroke-width: 6;\n    stroke-dasharray: 19;\n    stroke-dashoffset: 19;\n\n    &.checked {\n      stroke-dashoffset: 38;\n      stroke: ", ";\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    stroke-width: 1;\n    stroke: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: none;\n  vertical-align: middle;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &:hover ", ":not(.checked):not(.disabled) {\n      stroke-dashoffset: 38px;\n      stroke: ", ";\n    }\n\n    &:not(:first-child) {\n      margin-top: ", ";\n    }\n\n    ", " {\n      margin-left: ", ";\n    }\n\n    &.error {\n      color: ", ";\n\n      ", " {\n        color: ", ";\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from "react";
import styled, { css } from "styled-components";
import { Radio as BaseRadio, RadioStyles } from "@diana-ui/radio";
import classnames from "classnames";
var StyledRadio = styled(BaseRadio)((_ref) => {
  var {
    theme
  } = _ref;
  return css(_templateObject(), InnerPath, theme.colors.grey.grey100, theme.spaceUnit.xs, RadioStyles.StyledLabel, theme.spaceUnit.xs, theme.colors.alert.alert100, RadioStyles.StyledLabel, theme.colors.alert.alert100);
});
var Svg = styled.svg(_templateObject2());
var Circle = styled.circle((_ref2) => {
  var {
    theme
  } = _ref2;
  return css(_templateObject3(), theme.colors.black);
});
var InnerPath = styled.path((_ref3) => {
  var {
    theme
  } = _ref3;
  return css(_templateObject4(), theme.colors.black);
});
var OuterPath = styled.path((_ref4) => {
  var {
    theme
  } = _ref4;
  return css(_templateObject5(), theme.colors.black, theme.colors.grey.grey25, theme.colors.grey.grey100);
});

var Radio = (_ref5) => {
  var {
    children,
    disabled,
    selectedValue,
    value
  } = _ref5,
      props = _objectWithoutProperties(_ref5, ["children", "disabled", "selectedValue", "value"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledRadio, _extends({
    disabled: disabled,
    selectedValue: selectedValue,
    value: value
  }, props), /*#__PURE__*/React.createElement(Svg, {
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: "10",
    cy: "10",
    r: "9"
  }), /*#__PURE__*/React.createElement(InnerPath, {
    d: "M10,7 C8.34314575,7 7,8.34314575 7,10 C7,11.6568542 8.34314575,13 10,13 C11.6568542,13 13,11.6568542 13,10 C13,8.34314575 11.6568542,7 10,7 Z",
    className: classnames(value === selectedValue && "checked", disabled && "disabled")
  }), /*#__PURE__*/React.createElement(OuterPath, {
    d: "M10,1 L10,1 L10,1 C14.9705627,1 19,5.02943725 19,10 L19,10 L19,10 C19,14.9705627 14.9705627,19 10,19 L10,19 L10,19 C5.02943725,19 1,14.9705627 1,10 L1,10 L1,10 C1,5.02943725 5.02943725,1 10,1 L10,1 Z",
    className: classnames(value === selectedValue && "checked", disabled && "disabled")
  }))), children);
};

export default Radio;